module.exports = __webpack_public_path__ + "static/media/explosion.9cb76444.gif";